export const ttcabinetsConstants = {
  SET_CABINETS_REQUEST: 'SET_CABINETS_REQUEST',
  SET_CABINETS_SUCCESS: 'SET_CABINETS_SUCCESS',
  SET_CABINETS_FAILURE: 'SET_CABINETS_FAILURE',

  SET_SELECT_OPTIONS_REQUEST: 'SET_SELECT_OPTIONS_REQUEST',
  SET_SELECT_OPTIONS_SUCCESS: 'SET_SELECT_OPTIONS_SUCCESS',
  SET_SELECT_OPTIONS_FAILURE: 'SET_SELECT_OPTIONS_FAILURE',

  SET_REQUEST_IN_PROGRESS: 'SET_REQUEST_IN_PROGRESS',
};
